module.exports = __webpack_public_path__ + "img/park-live-footer-logo.441a939a.svg";